import React, { useState } from 'react';
import { Collapse, Layout } from 'antd';
import { ReactComponent as Minus } from '../../../assets/icons/minus.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';

const FaqPage = () => {
  const { Content } = Layout;
  const { Panel } = Collapse;

  const [activeKey, setActiveKey] = useState();
  return (
    <div className="grey-wrapper" style={{ paddingTop: '5rem' }}>
      <div className="landing-fourth-quarter">
        <div className="collapse-texts-wrapper">
          <div className="collapse-text">
            <text className="collapse-first-text">Συχνές Ερωτήσεις</text>
          </div>
          <div className="collapse-text">
            <text className="collapse-second-text">
              Όλα όσα πρέπει να γνωρίζετε για την διαδικασία
            </text>
          </div>
        </div>
        <div className="main-content" id="landing-info">
          <Collapse
            key="1"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '1' ? setActiveKey('') : setActiveKey('1')
            }
            activeKey={activeKey}
          >
            {/* <Panel
                    header={
                      <text className='panel-header-title'>
                        Όλα όσα πρέπει να γνωρίζετε για τη διαδικασία
                      </text>
                    }
                    key="1"
                  >
                    <div>
                      <p>
                        Το Πρόγραμμα «Αλλάζω Σύστημα Θέρμανσης και Θερμοσίφωνα»
                        επιχορηγεί νοικοκυριά για την αντικατάσταση ενεργοβόρων
                        ηλεκτρικών θερμοσίφωνων, με νέους σύγχρονης τεχνολογίας
                        ηλιακούς θερμοσίφωνες ή/και με σύστημα αντλίας θερμότητας.
                        Το πρόγραμμα περιλαμβάνει:
                      </p>
                    </div>
                  </Panel> */}
          </Collapse>

          <Collapse
            key="2"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '2' ? setActiveKey('') : setActiveKey('2')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text className="panel-header-title">
                  Σκοπός και Αντικείμενο
                </text>
              }
              key="2"
            >
              <div>
                <p>
                  Δυνητικοί ωφελούμενοι του Προγράμματος είναι μικρές και πολύ
                  μικρές επιχειρήσεις που επιθυμούν να πραγματοποιήσουν
                  επενδύσεις οι οποίες στοχεύουν, μεταξύ άλλων, στον
                  εκσυγχρονισμό της επιχείρησης, στην ψηφιακή αναβάθμιση, στην
                  υλοποίηση πράσινων παρεμβάσεων και στην βελτίωση της
                  βιωσιμότητας της επιχείρησης.
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            key="3"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '3' ? setActiveKey('') : setActiveKey('3')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text className="panel-header-title">
                  Τι συμβαίνει αν η αίτησή μου απορριφθεί;
                </text>
              }
              key="3"
            >
              <div>
                <p>
                  Σε περίπτωση απόρριψης της επένδυσης σου, θα λάβεις ενημέρωση
                  μέσω των στοιχείων επικοινωνίας που έχεις καταχωρήσει στην
                  πλατφόρμα, σχετικά με τους λόγους απόρριψης. Στη συνέχεια,
                  μπορείς να προβείς σε εκ νέου υποβολή επένδυσης, αφού
                  πραγματοποιήσεις τις απαραίτητες διορθώσεις.
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            key="4"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '4' ? setActiveKey('') : setActiveKey('4')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text className="panel-header-title">
                  Ποια είναι τα απαιτούμενα δικαιολογητικά για την αίτησή μου;
                </text>
              }
              key="4"
            >
              <div>
                <p>
                  Για την δημιουργία του επενδυτικού σχεδίου της εταιρείας σας
                  χρειάζεται να συνδεθείτε μέσω Taxis Login και στη συνέχεια να
                  εισάγετε τις δαπάνες που επιθυμείτε να πραγματοποιήσετε. Λοιπά
                  στοιχεία για την ολοκλήρωση της υποβολής της αίτησης θα
                  απαιτηθούν σύμφωνα με την σχετική πρόσκληση της τράπεζας που
                  θα επιλεγεί.
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            key="5"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '5' ? setActiveKey('') : setActiveKey('5')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text className="panel-header-title">
                  Πώς διασφαλίζεται η προστασία των δεδομένων μου;
                </text>
              }
              key="5"
            >
              <div>
                <p>
                  Προκειμένου να εκδοθεί το Voucher, θα πρέπει να ακολουθηθούν
                  τα παρακάτω βήματα:
                </p>
                <p>
                  Ωφελούμενοι:
                  <ol>
                    <li>
                      Να κάνουν εισαγωγή στην πλατφόρμα και υποβολή αίτησης
                    </li>
                    <li>
                      Εφόσον εγκριθεί τελικώς η αίτηση και λάβουν το κουπόνι στο{' '}
                      <b>e-mail </b>
                      τους μπορούν να απευθυνθούν σε προμηθευτή ώστε να
                      διαλέξουν εξοπλισμό και υπηρεσίες.
                    </li>
                  </ol>
                </p>
                <p>
                  Προμηθευτές:
                  <ol>
                    <li>
                      Θα πρέπει να κάνουν την εγγραφή τους στο Μητρώο
                      Προμηθευτών και να δηλώσουν τον εξοπλισμό τους
                    </li>
                    <li>
                      Εφόσον η αίτηση εγκριθεί πλέον μπορούν να εισέλθουν και
                      στην πλατφόρμα του προγράμματος.
                    </li>
                  </ol>
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            key="6"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '6' ? setActiveKey('') : setActiveKey('6')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text className="panel-header-title">
                  Ποια είναι η μέγιστη διάρκεια αποπληρωμής του δανείου;
                </text>
              }
              key="6"
            >
              <div>
                <p>Η διάρκεια αποπληρωμής του δανείου είναι έως 10 έτη.</p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            key="7"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '7' ? setActiveKey('') : setActiveKey('7')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text className="panel-header-title">
                  Πώς κατανέμεται η χρηματοδότηση των Δανείων ΤΑΑ;
                </text>
              }
              key="7"
            >
              <div>
                <p>
                  Το 50% του κόστους της επένδυσης σου δύναται να χρηματοδοτηθεί
                  με χαμηλότοκο δάνειο μέσω του ΤΑΑ, το 30%, τουλάχιστον, με
                  εμπορικό δάνειο και το 20%, τουλάχιστον, με Ίδια Κεφάλαια.
                </p>
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
